import {
  formConditionalContainer,
  FormConditionalContainerType,
  offerElementFormConditional,
  OfferElementFormConditionalType,
  OfferElementMainDetails,
  offerElementMainDetails,
} from '@/assets/locales/views/offerElements/offerElements.common.translation.pl.ts';
import { DictionariesListSearchFormModel } from '@/views/dictionaries/list/model/DictionariesListSearchForm.model.ts';
import { OfferElementDetailsPricesBasicAddFormModel } from '@/views/offerElements/details/components/pricesList/components/basicPrices/components/add/model/OfferElementDetailsPricesConditionalAddForm.model';

import {
  offerElementsDetailsDishPackageTranslation,
  OfferElementsDetailsDishPackageTranslation,
} from './dishPackage/offerElementDetails.diskPackage.translation.pl';

type FormBasicType = Record<keyof OfferElementDetailsPricesBasicAddFormModel, string>;
const formBasic: FormBasicType = {
  minimumPrice: 'Cena minimalna',
  quantity: 'Liczba minimalna',
  validFrom: 'Ważna od',
  validTo: 'Ważna do',
};

export type OfferElementDetailsTranslation = {
  dishPackage: OfferElementsDetailsDishPackageTranslation;
  items: {
    dialog: {
      items: {
        button: {
          cancel: string;
          submit: string;
        };
        form: Record<keyof Omit<DictionariesListSearchFormModel, 'active' | 'types'>, string>;
      };
    };
    title: string;
  };
  main: OfferElementMainDetails;
  noItems: string;
  prices: {
    basic: {
      form: FormBasicType & {
        button: {
          cancel: string;
          save: string;
        };
      };
      title: string;
    };
    conditional: {
      form: OfferElementFormConditionalType & {
        button: {
          cancel: string;
          save: string;
        };
      };
      item: {
        details: OfferElementFormConditionalType;
        main: FormConditionalContainerType;
      };
    };
    dialog: {
      container: {
        button: {
          cancel: string;
          save: string;
        };
        form: FormConditionalContainerType;
        title: {
          create: string;
        };
      };
    };
    table: {
      basic: {
        head: FormBasicType;
      };
    };
    title: string;
  };
};

export const offerElementDetailsTranslation: OfferElementDetailsTranslation = {
  dishPackage: offerElementsDetailsDishPackageTranslation,
  items: {
    dialog: {
      items: {
        button: {
          cancel: 'Anuluj',
          submit: 'Zapisz',
        },
        form: {
          fullTextSearchInput: 'Wyszukaj...',
        },
      },
    },
    title: 'Lista elementów',
  },
  main: offerElementMainDetails,
  noItems: 'Brak wpisów',
  prices: {
    basic: {
      form: {
        ...formBasic,
        button: {
          cancel: 'Anuluj',
          save: 'Zapisz',
        },
      },
      title: 'Dodaj cenę',
    },
    conditional: {
      form: {
        ...offerElementFormConditional,
        button: {
          cancel: 'Anuluj',
          save: 'Zapisz',
        },
      },
      item: {
        details: offerElementFormConditional,
        main: formConditionalContainer,
      },
    },
    dialog: {
      container: {
        button: {
          cancel: 'Anuluj',
          save: 'Zapisz',
        },
        form: formConditionalContainer,
        title: {
          create: 'Utwórz nowy zestaw',
        },
      },
    },
    table: {
      basic: {
        head: formBasic,
      },
    },
    title: 'Lista cen',
  },
};
